import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=e3a0c5d2"
import script from "./Button.vue?vue&type=script&setup=true&lang=ts"
export * from "./Button.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports